export type PriorityPrimitives = {
  id: number;
  name: string;
};

export class Priority {
  // Tasks without a priority sort after every prioritised one.
  static readonly LOWEST_RANK: number = Number.MAX_SAFE_INTEGER;

  private static readonly HIGHEST_ID: number = 1;
  private static readonly MEDIUM_ID: number = 2;

  constructor(public readonly id: number, public readonly name: string) {}

  static fromPrimitives(primitives: PriorityPrimitives): Priority {
    return new this(primitives.id, primitives.name);
  }

  // Filter criteria travel as strings: they come from form controls and are stored as such.
  get filterId(): string {
    return String(this.id);
  }

  // Id 1 is the highest urgency, so the id doubles as the ascending sort rank.
  get sortRank(): number {
    return this.id;
  }

  isHighest(): boolean {
    return this.id === Priority.HIGHEST_ID;
  }

  isMedium(): boolean {
    return this.id === Priority.MEDIUM_ID;
  }

  toPrimitives(): PriorityPrimitives {
    return {
      id: this.id,
      name: this.name,
    };
  }
}
